/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import * as _ from 'lodash';

import BUILD_INFO from '../../../gen-config/build-info';
import {getRegisteredUrl} from '../../config/registered-urls';
import template from './nude-shell-layout.html';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalNetworkInfo} from '../../../components/session/local-network-info';
import {WINDOW} from '../../angular-platform-providers';
import {ApiConfig} from '../../config/api-config';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule],
  selector: 'adn-nude-shell-layout',
  template
})
export class NudeShellLayoutComponent {
  uiLogo: string;
  releaseId: string;

  constructor(
    @Inject(WINDOW) window: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    apiConfig: ApiConfig,
    localNetworkInfo: LocalNetworkInfo = new LocalNetworkInfo()
  ) {
    const regUrl = getRegisteredUrl(window, apiConfig, localNetworkInfo, LocalNetworkProfile.get('networkId'));
    this.uiLogo = _.get(regUrl, ['logo']) || LocalNetworkProfile.get('adnUiLogo');
    this.releaseId = BUILD_INFO.gitSha.substring(0, 10);
  }
}
